import { render } from "./ProductOverview.vue?vue&type=template&id=3e3869a6"
import script from "./ProductOverview.vue?vue&type=script&lang=js"
export * from "./ProductOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__